import React, { useState, useRef, useEffect, forwardRef } from 'react';
import { FaPaperPlane } from 'react-icons/fa'
import './EditableComment.css';
import ProfileImage from './ProfileImage.js';

// 1. Wrap component in forwardRef
const EditableComment = forwardRef(({
  initialContent = '',
  placeholder = 'Write a comment...',
  showControls = true,
  commentId,
  autoFocus = false,
  handleSubmitComment,
  hideSelf,
  user,
}, ref) => {
  const [content, setContent] = useState(initialContent);
  const [isFocused, setIsFocused] = useState(autoFocus);
  const editableRef = useRef(null);

  // 3. Combine forwarded ref with internal ref
  useEffect(() => {
    if (ref) {
      ref.current = editableRef.current;
    }
  }, [ref]);

  useEffect(() => {
    if (editableRef.current && !content && initialContent) {
      editableRef.current.innerHTML = initialContent;
    }
  }, [initialContent]);

  // 4. Add auto-focus effect
  useEffect(() => {
    if (autoFocus && editableRef.current) {
      editableRef.current.focus();

      // Move cursor to end of content
      const range = document.createRange();
      const selection = window.getSelection();
      range.selectNodeContents(editableRef.current);
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }, [autoFocus]);
  const handleInput = (e) => {
    setContent(e.currentTarget.innerHTML);
  };

  const handleSubmit = () => {
    if (content.trim() || editableRef.current?.innerText.trim()) {

      handleSubmitComment(editableRef.current?.innerHTML || '', commentId)
      setContent('');
      if (editableRef.current) {
        editableRef.current.innerHTML = '';
      }
      hideSelf()
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const text = (e.clipboardData || window.clipboardData).getData('text');
    document.execCommand('insertText', false, text);
  };

  return (
    <div className="comment-wrapper">
      <ProfileImage profile={user} size={30} style={{ marginRight: '0.5rem' }} />
      <div style={{ marginLeft: '0.5rem' }} className={`comment-card editable-comment ${isFocused ? 'focused' : ''}`}>
        <div
          ref={editableRef}
          id={`editable-content-${commentId}`}
          className="editable-content"
          contentEditable
          onInput={handleInput}
          onKeyDown={handleKeyDown}
          onPaste={handlePaste}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          data-placeholder={placeholder}
          dangerouslySetInnerHTML={{ __html: initialContent }}
        />

        {showControls && (
          <div className="comment-controls">
            <button
              style={{ marginLeft: '0.5rem' }}
              className="sticky-comment-button"
              onClick={handleSubmit}
              disabled={!content.trim() || content == "<br>"}
              title={"Send reply"}
            >
              <FaPaperPlane />
            </button>
          </div>
        )}
      </div>
    </div>
  );
});

export default EditableComment;